import React from 'react';
import { AlertCircle } from 'lucide-react';

/**
 * Shown in place of the editor when the template it was asked to open cannot
 * be loaded, so the visitor never mistakes an empty canvas for the template.
 */
export default function TemplateUnavailable({ title, message, onBrowse, onRetry }) {
  return (
    <div className="h-screen flex items-center justify-center bg-gray-100 px-4">
      <div role="alert" className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-200 p-8 text-center">
        <div className="mx-auto mb-4 w-12 h-12 rounded-full bg-purple-50 flex items-center justify-center">
          <AlertCircle className="w-6 h-6 text-purple-600" aria-hidden="true" />
        </div>
        <h1 className="text-lg font-semibold text-gray-900">{title}</h1>
        <p className="mt-2 text-sm text-gray-600">{message}</p>
        <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
          <button
            type="button"
            onClick={onBrowse}
            className="h-10 px-5 rounded-lg bg-purple-600 hover:bg-purple-700 text-white text-sm font-semibold"
          >
            Browse templates
          </button>
          {onRetry && (
            <button
              type="button"
              onClick={onRetry}
              className="h-10 px-5 rounded-lg border border-gray-200 hover:bg-gray-50 text-gray-700 text-sm font-semibold"
            >
              Try again
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
